module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyrighta"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v("This is a work of fiction. All the characters and events portrayed in this novel are either fictitious or are used fictitiously.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("FOXMASK")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Copyright © 2003 by Juliet Marillier")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("First published in 2003 by Pan Macmillan Australia Pty Limited")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("All rights reserved, including the right to reproduce this book, or portions thereof, in any form.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("This book is printed on acid-free paper.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Maps by Bronya Marillier")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("A Tor Book"), _c('br'), _vm._v("Published by Tom Doherty Associates, LLC"), _c('br'), _vm._v("175 Fifth Avenue"), _c('br'), _vm._v("New York, NY 10010")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.tor.com",
      "target": "_blank"
    }
  }, [_vm._v("www.tor.com")])])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Tor"), _c('sup', [_vm._v("®")]), _vm._v(" is a registered trademark of Tom Doherty Associates, LLC.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightb"
  }, [_vm._v("Marillier, Juliet."), _c('br'), _vm._v("Foxmask / Juliet Marillier.—1st Tor ed.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightc"
  }, [_vm._v("p. cm.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightd"
  }, [_vm._v("“A Tom Doherty Associates book.”")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightd"
  }, [_vm._v("ISBN   0-765-30674-3")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightd"
  }, [_vm._v("EAN   978-0765-30674-6")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightd"
  }, [_vm._v("1. Vikings—Fiction. 2. Birthfathers—Fiction. 3. Fathers and sons—Fiction.4. Orkney (Scotland)—Fiction. I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightb1"
  }, [_vm._v("PR9619.3.M26755F69    2004"), _c('br'), _vm._v("823’.92—dc22")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("2003071154")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("First U.S. Edition: August 2004")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Printed in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("0  9  8  7  6  5  4  3  2  1")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-662c7b76","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 72
// module chunks = 0